import { Table2 } from "lucide-react";
import { useLanguage } from "../../context/LanguageContext";
import ToolPage from "./ToolPage";

export default function PDFtoExcel() {
  const { t } = useLanguage();
  const tk = t.tools.pdfToExcel;


  const config = {
    title: tk.title,
    description: tk.description,
    action: tk.action,
    hint: tk.dropHint,
    hintSub: tk.dropHintSub,
    endpoint: "/pdf/pdf-to-excel",
    accept: ".pdf",
    multiple: false,
    resultType: "download",
    resultFileName: tk.result,
    color: "#15803d",
    Icon: Table2,
    toolKey: "pdfToExcel",
  };

  return <ToolPage config={config} />;
}
